import { render, staticRenderFns } from "./AdminHomeWrapper.vue?vue&type=template&id=0b38f628"
import script from "./AdminHomeWrapper.vue?vue&type=script&lang=js"
export * from "./AdminHomeWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports